import EventsWebservice from "./EventsWebservice";
import { blumarWebserviceAxios } from "./HttpHelper";

let axios = blumarWebserviceAxios();

export default class ConfigurationService extends EventsWebservice{

	constructor() {
		super('/configurations');
  }

	getCampaignConfiguration(){
		return axios.get(this.url)
	}
}



// WEBPACK FOOTER //
// ./src/services/ConfigurationService.js